import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/lib/platform"; // side-effect: stamps `is-ios` on <html> for the iOS-only flip cross-fade branch
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
